module.exports = __webpack_public_path__ + "static/media/IMG_6684.4bc2fa31.JPG";